export const startupPlan: string[] = [
    "Reach out to us if you are a startup for your discount code.",
    "Choose any of the pricing options under Individual/ Business."
]